import { FC } from 'react';
import { useTrans } from 'base/utils/i18n';
import { Button } from 'antd';
import { RouteEnum } from 'pro/config/routers';
import Tracker from '@base/lib/Tracker';
import { getModuleCode } from 'base/utils/features';

type IProps = {
    trackPosition: string|number;
}

export const BtnSendReferral: FC<IProps> = ({trackPosition}) => {
    const { t } = useTrans();
    return (
        <Tracker
            data={{
                module: getModuleCode({ moduleId: 'Referral' }),
                targetType: 'other',
                target: 'SendAReferral',
                relTarget: 'SendAReferral',
                position: trackPosition
            }}
        >
            <Button
                type={'primary'}
                className={'g-btn-send'}
                href={RouteEnum.REFER_A_FRIEND}
                size={'large'}
            >
                {t('web_referral_send')}
            </Button>
        </Tracker>
    )
};
